'use client';

import BackToTopButton from '@/components/BackToTopButton';

export default function ClientLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <>
      {children}
      <BackToTopButton />
    </>
  );
}